"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSettingsHash = exports.getSettings = exports.getSavedSettingsHash = exports.getPath = exports.getHasChanges = exports.getForms = exports.getBreadcrumbs = exports.getBasePath = void 0;
var _reselect = require("reselect");
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getSettings = exports.getSettings = function getSettings(state) {
  return state.settings;
};
var getSettingsHash = exports.getSettingsHash = function getSettingsHash(state) {
  return state.settingsHash;
};
var getSavedSettingsHash = exports.getSavedSettingsHash = function getSavedSettingsHash(state) {
  return state.savedSettingsHash;
};
var getBasePath = exports.getBasePath = function getBasePath(state) {
  return state.basePath;
};
var getPath = exports.getPath = function getPath(state) {
  return state.path;
};
var getForms = exports.getForms = function getForms(state) {
  return state.forms;
};
var getHasChanges = exports.getHasChanges = (0, _reselect.createSelector)(getSettingsHash, getSavedSettingsHash, function (settingsHash, savedSettingsHash) {
  return settingsHash !== savedSettingsHash;
});
var getBreadcrumbs = exports.getBreadcrumbs = (0, _reselect.createSelector)(getSettings, getBasePath, getPath, getForms, function (settings, basePath, path, forms) {
  var pathNumbers = path.match(/\d+/g);
  var sanitizedPath = path.replace(/\d+/g, 'x');
  return forms.filter(function (form) {
    return form.path === '' || sanitizedPath === form.path || sanitizedPath.startsWith(form.path + '.') || sanitizedPath.startsWith(form.path + '[');
  }).sort(function (a, b) {
    return a.path.length - b.path.length;
  }).map(function (form) {
    var index = 0;
    var breadcrumbPath = form.path.replace(/\[x\]/g, function (_) {
      return "[".concat(pathNumbers[index++], "]");
    });
    var breadcrumbName = form.breadcrumb || 'Unknown';
    if (typeof breadcrumbName === 'function') {
      var partSettings = (0, _get2["default"])(settings, breadcrumbPath, {});
      breadcrumbName = form.breadcrumb(partSettings);
    }
    return {
      path: '/' + breadcrumbPath,
      name: breadcrumbName
    };
  }).filter(function (item) {
    return basePath === '' || item.path.startsWith('/' + basePath);
  });
});